// extracted by mini-css-extract-plugin
export var avatarContainer = "_4i-1";
export var largeAvatarContainer = "_4i-2";
export var smallAvatarContainer = "_4i-0";